const LABEL_PROPS = { fontFamily: "Space Mono, monospace", fontSize: 9, letterSpacing: 1.1, fill: "#3D4049" };

const Callout = ({ x, y, index, text }) => (
  <text x={x} y={y} {...LABEL_PROPS}><tspan fill="#D00508" fontWeight="600">{index}</tspan>{` · ${text}`}</text>
);

const Rack = ({ x }) => (
  <g>
    <rect x={x} y="238" width="24" height="112" fill="url(#ac-rack)" />
    {[0, 1, 2, 3, 4].map((row) => <g key={row}><line x1={x + 3} x2={x + 21} y1={252 + row * 20} y2={252 + row * 20} stroke="#FFFFFF" strokeOpacity=".14" /><circle cx={x + 5} cy={246 + row * 20} r="1.4" fill={row === 1 ? "#F6101A" : "#E7E9ED"} /></g>)}
  </g>
);

const CoolingUnit = ({ x }) => (
  <g>
    <path d={`M${x + 16} 158 q 4 -8 0 -15 q -4 -8 0 -15 M${x + 28} 158 q 4 -8 0 -15 q -4 -8 0 -15`} stroke="#8A94A2" strokeDasharray="2 3" fill="none" />
    <rect x={x} y="164" width="44" height="32" fill="url(#ac-chrome)" stroke="#160907" strokeOpacity=".6" />
    <circle cx={x + 22} cy="180" r="10" fill="none" stroke="#160907" strokeOpacity=".55" />
    <path d={`M${x + 22} 172 V188 M${x + 14} 180 H${x + 30}`} stroke="#160907" strokeOpacity=".45" />
  </g>
);

const Person = ({ x }) => (
  <g stroke="#160907" strokeOpacity=".75" fill="none" strokeLinecap="round">
    <circle cx={x} cy="351" r="3" fill="#160907" fillOpacity=".75" />
    <path d={`M${x} 355 V365 M${x} 365 L${x - 3} 372 M${x} 365 L${x + 3} 372 M${x - 4} 359 H${x + 4}`} />
  </g>
);

export const CampusIllustration = () => (
  <svg viewBox="0 0 600 410" role="img" aria-labelledby="campus-title campus-desc" data-testid="academy-campus-illustration" className="w-full h-auto">
    <title id="campus-title">Illustrated data center campus</title>
    <desc id="campus-desc">Grid power feeds a power yard with a transformer, UPS and generator. Cooling units sit on the roof of a data hall full of server racks. Fiber links the hall to a network room and the outside world, and a dashed outline marks a future development phase.</desc>
    <defs>
      <linearGradient id="ac-chrome" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#FFFFFF" /><stop offset="1" stopColor="#E3E5E9" /></linearGradient>
      <linearGradient id="ac-rack" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#2A2D34" /><stop offset="1" stopColor="#0B0C10" /></linearGradient>
    </defs>
    <line x1="12" y1="372" x2="588" y2="372" stroke="#160907" strokeOpacity=".5" />
    <g stroke="#160907" strokeOpacity=".7" fill="none">
      <path d="M44 372 L66 196 L88 372 M50 320 H82 M55 280 H77 M59 240 H73 M50 320 L77 280 M82 320 L55 280 M55 280 L73 240 M77 280 L59 240 M46 214 H86 M52 202 H80" />
      <path d="M86 214 Q 120 226 150 262" strokeOpacity=".45" />
    </g>
    <Callout x={18} y={186} index="01" text="POWER" />
    <rect x="112" y="262" width="96" height="110" fill="url(#ac-chrome)" stroke="#160907" strokeOpacity=".6" />
    <rect x="122" y="274" width="34" height="34" fill="#FFFFFF" stroke="#160907" strokeOpacity=".55" />
    <path d="M128 278 V304 M134 278 V304 M140 278 V304 M146 278 V304 M150 278 V304" stroke="#160907" strokeOpacity=".3" />
    <rect x="164" y="274" width="34" height="34" fill="#FFFFFF" stroke="#160907" strokeOpacity=".55" />
    <text x="170" y="294" {...LABEL_PROPS} fontSize="8">UPS</text>
    <rect x="122" y="320" width="76" height="40" fill="#FFFFFF" stroke="#160907" strokeOpacity=".55" />
    <text x="130" y="344" {...LABEL_PROPS} fontSize="8">GENERATOR</text>
    <path className="academy-flow" d="M208 344 H262" stroke="#F6101A" strokeWidth="1.6" fill="none" />
    <rect x="232" y="196" width="236" height="176" fill="#FFFFFF" stroke="#160907" strokeOpacity=".75" />
    <path d="M226 196 H474" stroke="#160907" strokeOpacity=".8" strokeWidth="2" />
    {[0, 1, 2, 3].map((index) => <CoolingUnit key={index} x={242 + index * 56} />)}
    <Callout x={242} y={120} index="02" text="COOLING" />
    <text x="244" y="224" {...LABEL_PROPS}>DATA HALL</text>
    {[0, 1, 2, 3, 4, 5].map((index) => <Rack key={index} x={248 + index * 34} />)}
    <Callout x={244} y={390} index="04" text="AI INFRASTRUCTURE" />
    <rect x="496" y="168" width="88" height="96" fill="none" stroke="#8A94A2" strokeDasharray="4 4" />
    <text x="506" y="222" {...LABEL_PROPS} fill="#5F6168">PHASE 2</text>
    <Callout x={482} y={158} index="05" text="DEVELOPMENT" />
    <path className="academy-flow" d="M468 318 H496" stroke="#F6101A" strokeWidth="1.6" fill="none" />
    <rect x="496" y="292" width="60" height="80" fill="url(#ac-chrome)" stroke="#160907" strokeOpacity=".6" />
    <path d="M504 304 H548 M504 312 H548 M504 320 H548" stroke="#160907" strokeOpacity=".35" />
    <text x="508" y="350" {...LABEL_PROPS} fontSize="8">NETWORK</text>
    <path className="academy-flow" d="M556 306 C 572 306 578 292 596 288 M556 322 C 574 322 580 320 596 320 M556 338 C 574 338 580 350 596 354" stroke="#F6101A" strokeWidth="1.4" fill="none" />
    <Callout x={474} y={284} index="03" text="CONNECTIVITY" />
    <Person x={220} />
    <Person x={456} />
    <Callout x={112} y={390} index="06" text="CAREERS" />
  </svg>
);
